/**
 * Created by root on 8/30/15.
 */

define(function (require) {

    var lpAMSController = require('web-agent-assets-js/lpAMSController');
    var lpBaseConnectionListController = require('web-agent-assets-js/lpBaseConnectionListController');

    /* --------------------------------- Constructor --------------------------------- */

    var lpMyConnectionListController = lpBaseConnectionListController.extend(function MyConnectionListController(options) {
    });

    /* --------------------------------- Overrides --------------------------------- */

    lpMyConnectionListController.prototype.applicationType = 'lpMyConnectionListController';

    lpMyConnectionListController.prototype.settings = {
        defaultSearchUIData: {
            limit: 50,
            skip: 0,
            sortTag: "SLA",
            sortOrder: "desc",
            filters: {
                conversationStates: {
                    selectedItems: [
                        lpAMSController.BADGES.IN_SURVEY,
                        lpAMSController.BADGES.NO_ACTIVE_DIALOG,
                        lpAMSController.CONVERSATION_STATES.OPEN,
                        lpAMSController.BADGES.FIRST_TIME,
                        lpAMSController.BADGES.URGENT,
                        lpAMSController.BADGES.OVERDUE
                    ].join(',')
                }
            }
        }
    };

    return lpMyConnectionListController;

});
